module.exports = __webpack_public_path__ + "images/icons/psp/electricity/home-storage.svg";